// 2_components/qr_calendar_modal.js
// QR codes on packaging lead to the product with ?utm_source=qr-kod&utm_content=<id>.
// If /qr-kody/<id>.ics exists on the store, offer it as a calendar reminder in a
// modal styled like the product share modal.

const FILES_PATH = "/user/documents/upload/shoptet_uploads/qr-kody/";
const ICON_CLOSE = "/user/documents/upload/assets/icons/nat-share-close.svg";
const ID_PATTERN = /^[a-z0-9-]+-[0-9a-f]{8}$/;

let lastActiveElement;

export function init() {
	const params = new URLSearchParams(window.location.search);
	const id = params.get("utm_content") || "";
	if (params.get("utm_source") !== "qr-kod" || !ID_PATTERN.test(id)) return;

	// Daily version so an updated .ics is not served from cache.
	const now = new Date();
	const version = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
	const fileUrl = FILES_PATH + id + ".ics?v=" + version;

	fetch(fileUrl, { method: "HEAD", cache: "no-store" })
		.then(function (response) {
			if (response.ok) openModal(fileUrl, id + ".ics");
		})
		.catch(function () {});
}

function openModal(fileUrl, fileName) {
	if (document.querySelector(".nat-share-modal--calendar")) return;

	const modal = document.createElement("div");
	modal.className = "nat-share-modal nat-share-modal--calendar";

	const dialog = document.createElement("div");
	dialog.className = "nat-share-modal__dialog";
	dialog.setAttribute("role", "dialog");
	dialog.setAttribute("aria-modal", "true");
	dialog.setAttribute("aria-labelledby", "nat-qr-calendar-title");

	const closeButton = document.createElement("button");
	closeButton.type = "button";
	closeButton.className = "nat-share-modal__close";
	closeButton.setAttribute("aria-label", window.NAT.translations("shareClose"));
	const closeIcon = document.createElement("img");
	closeIcon.src = ICON_CLOSE;
	closeIcon.alt = "";
	closeIcon.width = 58;
	closeIcon.height = 56;
	closeButton.appendChild(closeIcon);

	const title = document.createElement("p");
	title.className = "nat-share-modal__title";
	title.id = "nat-qr-calendar-title";
	const titleStrong = document.createElement("strong");
	titleStrong.textContent = window.NAT.translations("qrCalendarTitle");
	title.appendChild(titleStrong);

	const text = document.createElement("p");
	text.className = "nat-share-modal__text";
	text.textContent = window.NAT.translations("qrCalendarText");

	const download = document.createElement("a");
	download.className = "nat-share-modal__copy";
	download.href = fileUrl;
	download.download = fileName;
	download.textContent = window.NAT.translations("qrCalendarButton");

	dialog.appendChild(closeButton);
	dialog.appendChild(title);
	dialog.appendChild(text);
	dialog.appendChild(download);
	modal.appendChild(dialog);

	function onKeydown(event) {
		if (event.key === "Escape") closeModal();
	}

	function closeModal() {
		document.removeEventListener("keydown", onKeydown);
		document.body.classList.remove("scroll-lock");
		modal.remove();
		if (lastActiveElement && typeof lastActiveElement.focus === "function") {
			lastActiveElement.focus();
		}
	}

	modal.addEventListener("click", function (event) {
		if (event.target === modal) closeModal();
	});
	closeButton.addEventListener("click", closeModal);
	document.addEventListener("keydown", onKeydown);

	lastActiveElement = document.activeElement;
	document.body.appendChild(modal);
	document.body.classList.add("scroll-lock");
	closeButton.focus();
}
